import { EPriority } from '../../modules/points/priorities';
import { EStatus } from '../../shared/enums/status.enum';

export type TRelatedPointPayload = {
  type: ERelatedPointType;
  relatedPointId: string;
};

export type TSiteLightweight = {
  workspaceId: string;
  siteName: string;
};

export enum ERelatedPointType {
  RELATES_TO = 'RELATES_TO',
}

export enum ERelatedPointAction {
  ADDED = 'ADDED',
  REMOVED = 'REMOVED',
}

export type TRelatedPoint = {
  type: ERelatedPointType;
  pointId: string;
  pointTitle: string;
  pointTags: string[];
  pointStatus: EStatus;
  pointPriority: EPriority;
  siteId: string;
  siteName: string;
};
